import React, { Fragment, memo } from 'react';
import { injectIntl } from 'react-intl';
import { Backdrop as MuiBackdrop, Grow, withStyles } from '@material-ui/core';

import { Button } from 'shared/components';
import { useTrappedFocus } from 'shared/hocs/useTrappedFocus';
import FiltersAccordeon from '../FiltersAccordeon';

import theme from './FiltersPopover.scss';


const Backdrop = withStyles({
  root: {
    zIndex: 1,
  },
})(MuiBackdrop);


const FiltersPopover = ({ intl, popoverOpened, closePopover, resetAllAccordeonFilters }) => {
  const focusContainerRef = useTrappedFocus();

  return (
    <Fragment>
      <Grow in={ popoverOpened } unmountOnExit>
        <div className={ theme.filtersContainer } ref={ focusContainerRef }>
          <Button
            testId="appointments-clear-sort-by-filter"
            className={ theme.clearAllBtn }
            onClick={ resetAllAccordeonFilters }
            buttonType="naked"
            iconName="naked-x"
            size="xsmall"
            label={ intl.formatMessage({
              id: 'Appointments.AppointmentsList.Filter.ClearAllFiltersButton.Title',
              defaultMessage: '** Clear all filters',
            }) }
            labelColor="blackMedium"
            iconPositionLeft
            iconPositionRtlNotReversed
          />

          <FiltersAccordeon />
        </div>
      </Grow>

      { popoverOpened && (
        <Backdrop
          open={ popoverOpened }
          onClick={ closePopover }
          invisible
        />
      ) }
    </Fragment>
  );
};

export default memo(injectIntl(FiltersPopover));
